<!-- src/views/SkillsView.html -->
<div class="view-container">
  <div class="header-section">
    <div>
      <h1 class="view-title">Gestione Competenze</h1>
      <p class="view-desc">Configura e aggiorna le abilità professionali disponibili nel sistema.</p>
    </div>

    <!-- Contenitore Azioni Header -->
    <div class="header-actions">

      <!--
      <button class="theme-toggle-btn rounded-soft shadow-soft" @click="toggleTheme">
        <component :is="themeStore.darkMode ? 'Sun' : 'Moon'" :size="20" />
        <span>{{ themeStore.darkMode ? 'Chiaro' : 'Scuro' }}</span>
      </button>
      -->
      <!-- Bottone Aggiunta -->
      <button class="btn-primary rounded-soft" @click="openDrawer()">
        <Plus :size="18" />
        <span>Nuova Competenza</span>
      </button>
    </div>
  </div>

  <!-- Tabella Dati -->
  <div class="table-container rounded-soft shadow-soft">
    <table class="data-table">
      <thead>
        <tr>
          <th class="col-name">Competenza</th>
          <th class="col-desc">Descrizione</th>
          <th class="col-actions">Azioni</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="skills.length === 0">
          <td colspan="3" class="empty-state">
            Nessuna competenza trovata. Clicca su "Nuova Competenza" per aggiungerne una.
          </td>
        </tr>
        <tr v-for="skill in skills" :key="skill.id">
          <td class="font-medium">{{ skill.name }}</td>
          <td class="text-muted">{{ skill.description }}</td>
          <td class="actions-cell">
            <button class="btn-icon rounded-soft btn-edit" @click="openDrawer(skill)" title="Modifica">
              <Edit :size="16" />
            </button>
            <button class="btn-icon rounded-soft btn-delete" @click="deleteSkill(skill.id)" title="Elimina">
              <Trash2 :size="16" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Overlay per il pannello laterale -->
  <div 
    class="drawer-overlay" 
    :class="{ 'is-visible': isDrawerOpen }"
    @click="closeDrawer"
  ></div>

  <!-- Pannello laterale (Drawer) -->
  <div class="drawer" :class="{ 'is-open': isDrawerOpen }">
    <div class="drawer-header border-bottom">
      <h2>{{ editingSkill ? 'Modifica Competenza' : 'Nuova Competenza' }}</h2>
      <button class="btn-close" @click="closeDrawer">
        <X :size="20" />
      </button>
    </div>

    <div class="drawer-body">
      <form @submit.prevent="saveSkill" id="skill-form">
        <div class="form-group">
          <label for="name">Nome Competenza</label>
          <input 
            type="text" 
            id="name" 
            v-model="formName" 
            placeholder="Es: Taglio Capelli" 
            required 
          />
        </div>

        <div class="form-group">
          <label for="description">Descrizione</label>
          <textarea 
            id="description" 
            v-model="formDescription" 
            placeholder="Breve descrizione della qualifica o abilità..." 
            rows="5"
          ></textarea>
        </div>
      </form>
    </div>

    <div class="drawer-footer border-top">
      <button type="button" class="btn-secondary rounded-soft" @click="closeDrawer">
        Annulla
      </button>
      <button type="submit" form="skill-form" class="btn-primary rounded-soft">
        Salva
      </button>
    </div>
  </div>
</div>